const Command = Object.freeze({
  DRILLDOWN: 'DRILLDOWN',
  IMPORT: 'IMPORT',
  REPORT: 'REPORT',
  OPEN: 'OPEN',
  INVOCING: 'INVOCING',
});

export default Command;
